module.exports = __webpack_public_path__ + "img/icon-cancel-black.377d5ce4.svg";